import { urls } from 'constants/urls.constant';
import { DocumentPage } from 'flows/main/document';
import { DocumentsListPage } from 'flows/main/documents-list';
import { TaxLegislationComponent } from 'flows/main/tax-legislation';

import { AppRoute } from 'interfaces/route';

import { AuthGuard } from 'guards/auth.guard';
import { RoleGuard } from 'guards/role.guard';
import { withRouteParams } from 'guards/route-params.guard';
import { SignInGuard } from 'guards/sign-in.guard';
import { MainLayoutComponent } from 'features/layouts/main-layout';

export const routes: AppRoute[] = [
  { path: urls.home, redirectTo: urls.taxLegislation, pathMatch: 'full' },
  {
    path: urls.signIn,
    loadComponent: () => import('flows/sign-in/sign-in.component').then((m) => m.SignInComponent),
    canActivate: [SignInGuard],
    data: { accessibilitySpeech: true },
  },
  {
    path: urls.home,
    component: MainLayoutComponent,
    children: [
      {
        path: urls.taxLegislation,
        component: TaxLegislationComponent,
        data: { accessibilitySpeech: true },
      },
      {
        path: urls.documentsList,
        component: DocumentsListPage,
        data: {
          breadcrumbs: [{ title: 'document.titles.list-documents', url: urls.documentsList }],
          accessibilitySpeech: true,
        },
      },
      {
        path: urls.documentCreation,
        loadComponent: () => import('flows/main/document-creation').then((m) => m.DocumentCreationPage),
        data: {
          breadcrumbs: [{ title: 'administrative.titles.creation', url: urls.documentCreation }],
        },
        canActivate: [AuthGuard],
      },
      {
        path: urls.documentEdit(),
        loadComponent: () => import('flows/main/document-edit').then((m) => m.DocumentEditPage),
        data: {
          breadcrumbs: [{ title: 'administrative.titles.editing', url: urls._ }],
        },
        canActivate: [AuthGuard, withRouteParams('id')],
      },
      {
        path: urls.document(),
        component: DocumentPage,
        data: {
          breadcrumbs: [{ title: 'document.titles.details', url: urls._ }],
          accessibilitySpeech: true,
        },
        canActivate: [withRouteParams('id')],
      },
      {
        path: urls.dashboard,
        loadComponent: () => import('flows/admin/dashboard').then((m) => m.DashboardPage),
        data: {
          breadcrumbs: [{ title: 'dashboard.navigation.label', url: urls.dashboard }],
        },
        canActivate: [AuthGuard],
      },
      {
        path: urls.aiSalyk,
        loadComponent: () => import('flows/admin/ai-salyk').then((m) => m.AiSalykPage),
        data: {
          breadcrumbs: [{ title: 'ai-salyk.navigation.label', url: urls.aiSalyk }],
        },
        canActivate: [RoleGuard],
      },
      {
        path: urls.users,
        loadComponent: () => import('../flows/admin/users/users.page').then((m) => m.UsersPage),
        data: {
          breadcrumbs: [{ title: 'users.navigation.label', url: urls.users }],
        },
        canActivate: [RoleGuard],
      },
      {
        path: urls.logs,
        loadComponent: () => import('../flows/admin/audit/audit.page').then((m) => m.AuditPage),
        data: {
          breadcrumbs: [{ title: 'audit.navigation.label', url: urls.logs }],
        },
        canActivate: [RoleGuard],
      },
    ],
  },
  { path: '**', redirectTo: urls.taxLegislation, pathMatch: 'full' },
];
